export enum CallModalities {
  Unknown = 'unknown',
  Audio = 'audio',
  Video = 'video',
  VideoBasedScreenSharing = 'videoBasedScreenSharing',
  Data = 'data',
}

export interface StartCallParams {
  // List of user IDs representing the participants of the call.
  // Currently the User ID field supports the Azure AD UserPrincipalName,
  // typically an email address, or in case of a PSTN call, it supports a pstn
  // mri 4:<phonenumber>.
  targets: string[];
  // List of modalities for the call. Defaults to [“audio”].
  requestedModalities?: CallModalities[];
  // An optional parameter that informs about the source of the deep link
  source?: string;
}

export interface ICallService {
  startCall(startCallParams: StartCallParams): Promise<boolean>;
}
